var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame1171277065(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    width: 39,
    height: 39,
    rx: 12,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3375_19285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.659 19.2742H20.7987L11.7511 10.2266H20.6114L29.659 19.2742ZM20.6114 19.7266L29.659 28.7742H20.7987L11.7511 19.7266H20.6114Z",
    fill: "url(#paint0_linear_3375_19285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.659 19.2742H20.7987L11.7511 10.2266H20.6114L29.659 19.2742ZM20.6114 19.7266L29.659 28.7742H20.7987L11.7511 19.7266H20.6114Z",
    fill: "url(#paint1_linear_3375_19285)",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7541 19.2742H19.8938L10.8462 10.2266H19.7065L28.7541 19.2742ZM19.7065 19.7266L28.7541 28.7742H19.8938L10.8462 19.7266H19.7065Z",
    fill: "url(#paint2_linear_3375_19285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3375_19285",
    x1: 24.8582,
    y1: 4.37602,
    x2: 18.4567,
    y2: 28.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3375_19285",
    x1: 20.7051,
    y1: 10.1378,
    x2: 20.7051,
    y2: 28.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3375_19285",
    x1: 23.9533,
    y1: 4.49226,
    x2: 17.6087,
    y2: 28.4338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3375_19285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(10.3003 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171277065);
export default __webpack_public_path__ + "static/media/Frame 1171277065.444c2d8830c7dc4f1ae051113ef5979a.svg";
export { ForwardRef as ReactComponent };